export default __webpack_public_path__ + "7c9aeee503157b59d8aba8e728d1700f.png";